export enum MerchantConfigurationGroupEnum {
  Reporting = 'REPORTING',
  Deliveroo = 'DELIVEROO',
  UberEats = 'UBER_EATS',
  Flyt = 'FLYT',
  POS = 'POSService',
  Synergy = 'SYNERGY',
}